// MakeDifference.jsx
import React from 'react';
import { individuals, corporates, corporates1 } from '../resources/activities';
import '../scss/MakeDifference.scss';

function MakeDifference() {
    return (
        <div className="make-difference-page">
            <div className="make-difference-container">
                
                {/* Hero Section */}
                <section className="hero-section">
                    <div className="hero-content">
                        <span className="hero-badge">Join Us</span>
                        <h1 className="hero-title">Get Involved</h1>
                        <p className="hero-description">
                            We accept volunteers from all walks of life and we are always looking for fresh ideas.
                            Volunteers can choose how to assist us based on our needs and their skills.
                        </p>
                        <div className="hero-highlight">
                            <strong>GET INVOLVED</strong>....together we can make a difference
                        </div>
                    </div>
                </section>

                {/* Individuals Section */}
                <section className="involvement-section individuals-section">
                    <div className="section-header">
                        <div className="header-decoration">
                            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                <circle cx="9" cy="7" r="4"/>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                            </svg>
                        </div>
                        <h2>Individuals</h2>
                    </div>

                    <div className="skills-grid">
                        {individuals.map(({ skill, text }, index) => (
                            <div key={index} className="skill-card">
                                <div className="skill-header">
                                    <span className="skill-number">{String(index + 1).padStart(2, '0')}</span>
                                    <h3 className="skill-name">{skill}</h3>
                                </div>
                                <p className="skill-description">{text}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Corporates Section */}
                <section className="involvement-section corporates-section">
                    <div className="section-header">
                        <div className="header-decoration corporate">
                            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                <line x1="3" y1="9" x2="21" y2="9"/>
                                <line x1="9" y1="21" x2="9" y2="9"/>
                            </svg>
                        </div>
                        <h2>Corporate Partners</h2>
                    </div>

                    <div className="corporate-content">
                        <p className="corporate-intro">
                            There is a large gap that needs to be bridged if we wish to empower the vulnerable and less privileged. 
                            The resources needed to achieve this are limitless and even a small drop in this vast ocean is welcome.
                        </p>

                        <div className="donation-options">
                            <div className="option-block">
                                <h3 className="option-title">
                                    <span className="title-icon">💡</span>
                                    Specific Purpose Donations
                                </h3>
                                <p className="option-subtitle">
                                    Make a lump sum donation towards a specific purpose that your company would like to support:
                                </p>
                                <ul className="option-list">
                                    {corporates.map((item, index) => (
                                        <li key={index} className="option-item">
                                            <span className="bullet"></span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="option-block">
                                <h3 className="option-title">
                                    <span className="title-icon">🔄</span>
                                    Recurring Expenses
                                </h3>
                                <p className="option-subtitle">
                                    Help us meet our ongoing operational needs:
                                </p>
                                <ul className="option-list">
                                    {corporates1.map((item, index) => (
                                        <li key={index} className="option-item">
                                            <span className="bullet"></span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="cta-box">
                            <div className="cta-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                                </svg>
                            </div>
                            <div className="cta-content">
                                <h3>Enable Collection at Your Premises</h3>
                                <p>
                                    CURE can place donation boxes at your office premises or retail outlets 
                                    to help your employees and customers contribute to our cause.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    );
}

export default MakeDifference;